import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/main-dashboard/dashboard.component';
import { SearchComponent } from './search/search/search.component';
import { HospitalProfileComponent } from './profile/hospital-profile/hospital-profile.component';
import { SystemProfileComponent } from './profile/system-profile/system-profile.component';
import { GlossaryComponent } from './glossary/glossary.component';

const APP_ROUTES: Routes = [
  { path: '', component: DashboardComponent, data: { title: 'DashBoard' } },
  { path: 'glossary', component: GlossaryComponent, data: { title: 'Glossary' } },
  { path: 'searchResults', component: SearchComponent, data: { title: 'SearchResults' } },
  {
    path: 'hospitalProfile/:id',
    component: HospitalProfileComponent,
    data: { title: 'HospitalProfile' }
  },
  { path: 'systemProfile/:id', component: SystemProfileComponent, data: { title: 'SystemProfile' } }
];

// we want to set these routes for our root component, main routes of app
export const routing = RouterModule.forRoot(APP_ROUTES);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts